import React from 'react';

import {NotificationBar} from '@optimaxdev/design-system';

import {OrderErrorType} from 'constants/constants';

import s from './placeOrderErrors.scss';

type DefaultOrderErrorType = {
    title: string;
    friendlyMessage?: string;
};

/**
 * Error message
 *
 * @param {DefaultOrderErrorType} props - component props
 * @returns {FC} - component
 */
const DefaultError = ({friendlyMessage, title}: DefaultOrderErrorType) => (
    <p>{friendlyMessage || title}</p>
);

/**
 * Error message in notification Bar
 *
 * @param {DefaultOrderErrorType} props - component props
 * @returns {FC} - component
 */
const ErrorWithBar = ({friendlyMessage, title}: DefaultOrderErrorType) => {
    const text = friendlyMessage || title;
    const split = (text || '').split('.');

    return (
        <NotificationBar iconType="AdditionalInfo" type="warning" hasIcon>
            {split.length >= 2 ? (
                <span>
                    <b>{split[0]}.</b> {split.slice(1).join('. ')}
                </span>
            ) : (
                <span>{text}</span>
            )}
        </NotificationBar>
    );
};

const ERRORS = {
    DEFAULT: DefaultError,
    NOTIFICATION_BAR: ErrorWithBar,
};

type PropsType = {
    errors: Array<OrderErrorType>;
    errorComponentType?: keyof typeof ERRORS;
};

/**
 * Displays errors on place order step and send analytics
 *
 * @param {PropsType} props - component props
 * @constructor
 */
export const PlaceOrderErrors: React.FC<PropsType> = ({errorComponentType, errors}) => {
    const ErrorComponent = (errorComponentType && ERRORS[errorComponentType]) || ERRORS.DEFAULT;

    return (
        <div className={s.error} data-exp="place-order-error">
            {errors.map((error: OrderErrorType) => {
                return <ErrorComponent {...error} key={error.title} />;
            })}
        </div>
    );
};
